import { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Card, CardContent } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectDescription, postProjectDescription } from '../../../../../actions/tigercat-burns/tigercat-base-actions';

const ProjectDescription = ({ projectId }) => {
    const dispatch = useDispatch();
    const [data, setData] = useState({ description: '' });

    const descriptionData = useSelector(state => state.tigercatBurnsBaseReducer.projectDescription.data)

    const handleSave = () => {
        dispatch(postProjectDescription(projectId, 'description', data))
    };

    useEffect(() => {
        dispatch(getProjectDescription(projectId, 'description'));
    }, [projectId, dispatch]);

    useEffect(() => {
        if (descriptionData && typeof descriptionData.description === 'string') {
            setData({ description: descriptionData.description });
        }
    }, [descriptionData]);

    return (
        <Card sx={{ maxWidth: '800px', mx: 'auto', mt: 4 }}>
            <Box sx={{ ml: 2 }}>
                <h2>Project Description</h2>
            </Box>
            <CardContent>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    Please provide a description of the project, including:
                    <br />
                    a. Feedstock characterization;
                    <br />
                    b. Biochar production process(es) employed, including technology and general production parameters (e.g., production temperature and residence time);
                    <br />
                    c. End uses of biochar.
                </Typography>

                <TextField
                    fullWidth
                    multiline
                    minRows={4}
                    placeholder="Add text"
                    value={data.description}
                    onChange={(e) => setData({ description: e.target.value })}
                    sx={{ mb: 3 }}
                />

                <Button variant="contained" onClick={handleSave}>
                    Save
                </Button>
            </CardContent>
        </Card>
    );
};

export default ProjectDescription;